import i18n from '../i18n';
import { getCookie, isStringValidJSON } from './';
import dayjs from '@utils/dayjs';

export const onMonthPickerChange = (newValue, oldValue, setSelectedValue) => {
    if (!oldValue || !dayjs(newValue).isSame(dayjs(oldValue), 'month')) {
        setSelectedValue(newValue);
    }
};

export const getOptionLabelDependingOnLabelKeys = (option, labelKeys) => {
    const getNestedValue = (obj, path) => {
        const keys = path.split('.');
        return keys.reduce((acc, key) => acc && acc[key], obj);
    };

    let label = '';
    labelKeys.forEach((key, index) => {
        const value = key.includes('.') ? getNestedValue(option, key) || '' : option[key];
        const nextValue =
            index < labelKeys.length - 1 && key.includes('.')
                ? getNestedValue(option, labelKeys[index + 1]) || ''
                : option[labelKeys[index + 1]];
        if (value) {
            label += value;
            if (nextValue) {
                label += ' - ';
            }
        }
    });
    return label;
};

export const getSelectedWorktypeDependingOnCookie = (worktypes) => {
    if (worktypes.length > 0) {
        const cookieWorktype = parseInt(getCookie('worktype'));
        const cookieWorktypeInWorktypeOptions = worktypes.find((worktype) => worktype.id === cookieWorktype);
        if (cookieWorktypeInWorktypeOptions) return cookieWorktypeInWorktypeOptions;
        else return worktypes[0];
    }
};

export const getAllHourSlots = () => {
    let allHourSlots = [];
    for (let i = 7; i <= 22; i++) {
        allHourSlots = [...allHourSlots, `${i < 10 ? `0${i}` : i}:00`, `${i < 10 ? `0${i}` : i}:30`];
    }

    return allHourSlots;
};

export const setCommonStateAfterDataUpload = (setLoading, setPercentage, closeDropzoneDialog) => {
    setLoading(false);
    setPercentage(0);
    closeDropzoneDialog();
};

// These two are plain functions, not components, so they read the i18n singleton directly (as
// useAxiosInterceptor does) instead of taking a `t` from every one of their four callers. Resolved at
// call time, so a language switch is picked up.
export const showSuccessfulUploadNotification = (dispatchAlert) => {
    dispatchAlert({
        message: i18n.t('notification.uploadCompleted'),
        type: 'success',
        useSnackbar: false,
    });
};

export const showErrorUploadNotification = ({ dispatchAlert, errorMessage, customErrorMessage }) => {
    const defaultErrorMessage = i18n.t('notification.uploadFailed');

    showErrorNotification({
        dispatchAlert,
        message: errorMessage || customErrorMessage || defaultErrorMessage,
        useSnackbar: false,
    });
};

export const showErrorNotification = ({ dispatchAlert, message, useSnackbar }) => {
    dispatchAlert({
        message,
        type: 'error',
        useSnackbar,
        autoHideDuration: 10000,
    });
};

export const ifDateLocationAndWorktype = ({ date, location, worktype }) => !!date && !!location && !!worktype;

export const ifDateAndWorktype = ({ date, worktype }) => !!date && !!worktype;

export const handleDatePickerMonthChange = (oldValue, newValue, setNewValue) => {
    if (!oldValue || !newValue?.isSame(oldValue, 'month')) {
        setNewValue(newValue);
    }
};

export const fieldIsRequiredMsg = 'Pflichtfeld';

export const parseUploadResponse = (res, recordName) => {
    let response = res[0];
    if (!response) {
        console.error('Empty upload response:', res);
        throw new Error(`Invalid response format for ${recordName} upload`);
    }
    if (!isStringValidJSON(response)) {
        const jsonObjectStart = response.indexOf('{');
        const jsonArrayStart = response.indexOf('[');

        // Determine if the response is an object or an array
        if (jsonArrayStart !== -1 && (jsonArrayStart < jsonObjectStart || jsonObjectStart === -1)) {
            // Response is an array
            response = response.substring(jsonArrayStart);
        } else if (jsonObjectStart !== -1) {
            // Response is an object
            response = response.substring(jsonObjectStart);
        } else {
            // No valid JSON start found
            console.error('No valid JSON start found in response:', response);
            throw new Error(`Invalid response format for ${recordName} upload`);
        }
    }
    try {
        return JSON.parse(response);
    } catch (error) {
        console.error('Error parsing response:', response);
        throw new Error(`Error parsing response for ${recordName} upload`);
    }
};
